import {
    fetchApiData,
    fetchApiDataV2,
    commentImageUpload,
    commentGifUpload, updateApiData
} from "../../utils/utils";

export const getVideoDetails = async (id, appInfo, showId) => {
    const api = `video/details/${id}`
    const params = showId ? {show_id: showId} : null
    return await fetchApiDataV2(appInfo, api, params)
}

export const getShowDetails = async (appInfo, showId) => {
    const api = `show/details/${showId}`
    return await fetchApiDataV2(appInfo, api)
}
export const getSimilarVideos = async (appInfo, showId) => {
    const api = `show/similar/${showId}`
    return await fetchApiDataV2(appInfo, api)
}
export const commentImageUploadThumbnail = async (data, appInfo) => {
    const api = `comments/image`

    return await commentImageUpload(data, appInfo, api)
}
export const commentGifUploadThumbnail = async (data, appInfo) => {
    const api = `comments/gif`

    return await commentGifUpload(data, appInfo, api)
}

/**
 * Fetch comments for a specific video,
 * VideoID is treated as postID in the comments API
 */
export const fetchComments = async (appInfo, params) => {
    const api = `communityV2/comments`
    return await fetchApiData(appInfo, api, params)
}

export const createComment = async (appInfo, data) => {
    const api = `communityV2/comments/create`
    return await updateApiData(appInfo, api, { values: data }, false)
}

export const editComment = async (appInfo, commentId, data) => {
    const api = `communityV2/comments/${commentId}/edit`
    return await updateApiData(appInfo, api, { values: data }, false)
}

export const likeDislikeComment = async (appInfo, commentId, data) => {
    const api = `communityV2/comments/${commentId}/like`
    return await updateApiData(appInfo, api, { values: data })
}

export const deleteComment = async (appInfo, commentId, postId) => {
    const api = `communityV2/comments/${commentId}/delete`;
    return await updateApiData(appInfo, api, { values: { post_id: postId } } );
};

export const commentReport = async (appInfo, data) => {
    const api = `communityV2/report`;
    return await updateApiData(appInfo, api, { values: data }, false );
}

export const fetchCommentReplies = async (appInfo, commentId, { page, reply_id } = {}) => {
    const api = `communityV2/comments/${commentId}/replies`;
    const params = {};
    if (page) params.page = page;
    if (reply_id) params.reply_id = reply_id;
    return await fetchApiData(appInfo, api, params);
};